import { createContext } from "react";
import { contextFunctionInit } from "sprint-common-web";

import { DeliveryBucketItem } from "../listing/DeliveryBucketItem";

interface IDeliveryBucketListingContext {
    deliveryBucketItems: DeliveryBucketItem[];
    isLoading: boolean;
    addDeliveryBucketItem(deliveryBucket: DeliveryBucketItem): void;
    deleteDeliveryBucketItem(deliveryBucketId: string): void;
    disableDeliveryBucketItem(deliveryBucketId: string): void;
    enableDeliveryBucketItem(deliveryBucketId: string): void;
}

const defaultDeliveryBucketListingContext: IDeliveryBucketListingContext = {
    deliveryBucketItems: [],
    isLoading: false,
    addDeliveryBucketItem: contextFunctionInit,
    deleteDeliveryBucketItem: contextFunctionInit,
    disableDeliveryBucketItem: contextFunctionInit,
    enableDeliveryBucketItem: contextFunctionInit
};

export const DeliveryBucketListingContext = createContext<IDeliveryBucketListingContext>(
    defaultDeliveryBucketListingContext
);
